import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { createQuery, IQuery, PaginatedResults } from '@utils';
import { first, pluck } from 'rxjs/operators';

import { API_URL } from '../../core.tokens';
import { User } from '../../models/users.model';

@Injectable()
export class UsersCoreService {

  constructor(
    protected http: HttpClient,
    @Inject(API_URL) protected apiUrl: string
  ) { }

  getOverviewByQuery(query: IQuery) {
    return this.http.post<PaginatedResults<User>>(`${this.apiUrl}/user/overview`, query).pipe(first());
  }

  getByQuery(query: IQuery) {
    return this.http.post<PaginatedResults<User>>(`${this.apiUrl}/user/query`, query).pipe(first());
  }

  getListByRoleOperator() {
    return this.http.get<User[]>(`${this.apiUrl}/user/list/role/operator`).pipe(first());
  }

  getListByName(name?: string, size = 1000) {
    const query = createQuery({
      filter: {
        logic: 'or',
        filters: [
          { field: 'firstname', op: 'contains', value: name },
          { field: 'lastname', op: 'contains', value: name }
        ]
      },
      size
    });
    return this.getByQuery(query).pipe(pluck('results'));
  }
}
